import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DistributorManufacturer } from '../distributor-manufacturer.model';
import { UtilsService } from 'src/app/shared/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { ManagePlanComponent } from '../manage-plan/manage-plan.component';
import { ExportService } from 'src/app/shared/export.service';

@Component({
    selector: 'app-distributors',
    templateUrl: './distributors.component.html',
    styleUrls: ['./distributors.component.scss'],
    standalone: false
})
export class DistributorsComponent implements OnInit {
  showSearch: boolean;
  searchForm!: FormGroup;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  distributorsList = new Array<DistributorManufacturer>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null
  };

  searchValue = "";

  constructor(private router: Router, public dataService: DataService, private authService: AuthService,
              private route: ActivatedRoute,
              public utils: UtilsService,
              private dialog: MatDialog,
              private exportService: ExportService
              ) {
    this.showSearch = false;
    this.userID = this.authService.getUserData().id;

    this.route.queryParams.subscribe((params: Params) => {
      if (!this.isEmpty(params)) {
        this.pageNumber = params.pageNumber ? params.pageNumber : 1;
        this.pageSize = params.pageSize ? params.pageSize : 10;
        this.searchValue =  params.searchValue ? params.searchValue : "";
      }
      this.getDistributors();
    });
   }

   isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  ngOnInit(): void {
    this.utils.setTitle('Distributors');
    this.utils.screenTitle.emit({firstTitle: 'Distributors', firstRoute: '/distributors'});
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  managePlan(item: any) {
    const dialogRef = this.dialog.open(ManagePlanComponent, {
      disableClose: true,
      width: '400px',
      data: {
        currentPlan: item.plan,
        id: item.id,
      }
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  getDistributors() {
    this.dataService.get('distributor/RetrieveDistributors?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.distributorsList = [];
        const distributorsData = data.data.records;
        this.totalSize = data.data.count;
        distributorsData.forEach((distributorData: any) => {
          const distributorInstance = new DistributorManufacturer(distributorData);
          this.distributorsList.push(distributorInstance);
        });
        if (distributorsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
          this.router.navigate(['/distributors'], { queryParams: this.queryParams });
        }
      }
    });
  }
  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
    this.router.navigate(['/distributors'], { queryParams: this.queryParams });
  }
  handleSearchClick() {
    if (this.showSearch && this.distributorsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }
  onImgError(event: any) {
    this.utils.theme$.subscribe((isDark: any) => {
      event.target.src  = isDark
        ? '../../../assets/images/distributor-dark.png'
        : '../../../assets/images/distributor-light.png';
    });
  }
  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });

    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
      this.router.navigate(['/distributors'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue
    };
    this.router.navigate(['/distributors'], { queryParams: this.queryParams });
  }

  goToDistributor(name: any, id: number) {
    this.router.navigate(['/distributors/distributor/' + id + '/' + name]);
  }

  async block(id: any){
    await this.utils.blockUser(id, this.dataService);
    this.getDistributors();
  }

  async unblock(id: any){
    await this.utils.unBlockUser(id, this.dataService);
    this.getDistributors();
  }

  exportDistributors(fileTypeId: number) {
    this.exportService.exportFile('distributor/ExportDistributors', fileTypeId, this.searchValue, 'distributors');
  }

}
